

export function toolVersionVerify() {
  const newVersion = process.env.VUE_APP_VERSION ? process.env.VUE_APP_VERSION : ''
  const localVersion = window.localStorage.getItem('VUE_APP_VERSION') ? window.localStorage.getItem('VUE_APP_VERSION') : ''
  if (newVersion != localVersion) {
    window.localStorage.setItem('VUE_APP_VERSION', newVersion) 
    window.location.reload(true)
  }
}